export default __webpack_public_path__ + "static/media/icn_clone.36ef2ac6.svg";